import { BREAKPOINTS } from '../config';

const { mqTouch } = BREAKPOINTS;
const mq = window.matchMedia(`(max-width: ${mqTouch}px)`);

const carousels = document.querySelectorAll('.banner__carousell');

const originalMarkup = new WeakMap();

function getOriginalMarkup(list) {
  if (!originalMarkup.has(list)) {
    originalMarkup.set(list, list.innerHTML);
  }
  return originalMarkup.get(list);
}

function setupCarousel(carousel) {
  const list = carousel.querySelector('.banner__list');
  if (!list) return 0;

  const markup = getOriginalMarkup(list);
  list.innerHTML = markup;

  const carouselWidth = carousel.clientWidth;

  let safety = 0;
  while (list.scrollWidth < carouselWidth && safety < 20) {
    list.insertAdjacentHTML('beforeend', markup);
    safety++;
  }

  const gap = parseFloat(getComputedStyle(list).gap) || 0;
  const loopWidth = list.scrollWidth + gap;

  list.insertAdjacentHTML('beforeend', list.innerHTML);

  return loopWidth;
}

function animateCarousel(carousel, loopWidth) {
  const list = carousel.querySelector('.banner__list');
  if (!list || !loopWidth) return;

  const speedDesk = parseFloat(carousel.dataset.speedDesk) || 80;
  const speedMob = parseFloat(carousel.dataset.speedMob) || 60;
  const speed = mq.matches ? speedMob : speedDesk;

  const duration = loopWidth / speed;

  const isRTL = document.documentElement.dir === 'rtl';

  const reverse = 'reverse' in carousel.dataset ? !isRTL : isRTL;

  list.style.setProperty('--loop-width', `${loopWidth}px`);
  list.style.animationDuration = `${duration}s`;
  list.style.animationDirection = reverse ? 'reverse' : 'normal';
  list.style.animationPlayState = 'running';
  list.style.opacity = '1';
}

function initCarousel(carousel) {
  const loopWidth = setupCarousel(carousel);
  animateCarousel(carousel, loopWidth);
}

function initAll() {
  carousels.forEach(initCarousel);
}

// Анімація крутиться нескінченно, тож поки стрічку не видно — тримаємо її на
// паузі. Менше роботи композитора під час скролу, довше живе батарея.
function observeVisibility() {
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(({ target, isIntersecting }) => {
        const list = target.querySelector('.banner__list');
        if (!list || !list.style.animationDuration) return;
        list.style.animationPlayState = isIntersecting ? 'running' : 'paused';
      });
    },
    { rootMargin: '100px 0px' }
  );

  carousels.forEach(carousel => observer.observe(carousel));
}

let resizeTimer = null;
let lastWidth = window.innerWidth;

function handleResize() {
  // На iOS адресний рядок згортається під час скролу — це змінює лише висоту
  // вікна, але кидає resize. Перебудова стрічки на кожен такий resize скидає
  // анімацію на початок, і рядок смикається. Реагуємо тільки на зміну ширини.
  if (window.innerWidth === lastWidth) return;
  lastWidth = window.innerWidth;

  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(initAll, 150);
}

window.addEventListener('load', () => {
  requestAnimationFrame(() => requestAnimationFrame(initAll));
  observeVisibility();
});

window.addEventListener('resize', handleResize);
mq.addEventListener('change', initAll);
